import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "../models/user";
import { environment } from "src/environments/environment";
import { HttpService } from "./http.service";
import { UserAccount } from "src/app/shared/models/user-account";

import { Location } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NotificationService } from "src/app/shared/notification.service";
import { AppService } from "./app.service";
import { ActivityType } from "src/app/shared/ActivityType";
import { MatDialog } from "@angular/material/dialog";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  // private currentUserSubject: BehaviorSubject<User>;
  // public currentUser: Observable<User>;
  private currentUserSubject: BehaviorSubject<UserAccount>;
  public currentUser: Observable<UserAccount>;
  private userAccount: UserAccount;
  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    private location: Location,
    private router: Router,
    private notificationService: NotificationService,
    private appService: AppService,
    public dialog: MatDialog
  ) {
    // this.currentUserSubject = new BehaviorSubject<User>(
    //   JSON.parse(localStorage.getItem("currentUser"))
    // );
    // this.currentUser = this.currentUserSubject.asObservable();
    this.currentUserSubject = new BehaviorSubject<UserAccount>(
      JSON.parse(window.localStorage.getItem("CurrentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.userAccount = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  public get currentUserValue(): UserAccount {
    return this.currentUserSubject.value;
  }

  // public get currentUserValue(): User {
  //   return this.currentUserSubject.value;
  // }

  // login(username: string, password: string) {
  //   return this.http
  //     .post<any>(`${environment.apiUrl}/authenticate`, {
  //       username,
  //       password,
  //     })
  //     .pipe(
  //       map((user) => {
  //         // store user details and jwt token in local storage to keep user logged in between page refreshes

  //         localStorage.setItem('currentUser', JSON.stringify(user));
  //         this.currentUserSubject.next(user);
  //         return user;
  //       })
  //     );
  // }

  // logout() {
  //   // remove user from local storage to log user out
  //   localStorage.removeItem('currentUser');
  //   this.currentUserSubject.next(null);
  //   return of({ success: false });
  // }

  Login(loginDetails: any): Observable<any> {
    return this.httpService.postAnonymous(
      "security/Authenticate",
      loginDetails
    );
  }

  Logout(userDetails: any): void {
    this.AddUserActivity(userDetails);
  }

  AddUserActivity(userDetails) {
    var userActivity = {
      ActivityType: ActivityType.Logout,
      ActivityName: "User Logout",
      UserName: userDetails.FirstName + " " + userDetails.LastName,
      Description:
        userDetails.FirstName + " " + userDetails.LastName + " Logged out",
      UserAccountId: userDetails.Id,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.dialog.closeAll();
          sessionStorage.clear();
          localStorage.removeItem("CurrentUser");
          this.router.navigate(["/authentication/signin"]);
        }
      },
      error: () => {},
    });
  }

  goBack() {
    this.location.back();
  }

  showNotification(colorName, text, placementFrom, placementAlign) {
    this.snackBar.open(text, "", {
      duration: 2000,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
    });
  }
}
